import { Bitmap, ButtonBase, delayedCall, dispatcher, Graphics, IEvent, ingenuity, ITween, killDelayedCall, Linear, SpineBase } from "@quest/base-core";
import { BaseController, ButtonBaseBehavior, MeterBehavior, SlotConstantsBehavior, SlotEventConstantsBehavior, SoundConstant } from "@quest/murka-games-behavior-panther/dist";
import { GameParserModel } from "../Platform/GameParserModel";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { gameConstants } from "../Constants/gameConstants";
import { SoundConstantGame } from "../Constants/SoundConstantGame";
import { EventConstants } from "@quest/platform-murka-phase_2";

export class BaseControllerGame extends BaseController {
  // private reelMask: Graphics;

  // private STR_REEL_MASK: string = "reelMask";
  private boardButton: ButtonBase;
  private reelBgAnim: SpineBase;
  private NoteBackMeterText: MeterBehavior;
  private MagnifyMeterText: MeterBehavior;
  private KeyMeterText: MeterBehavior;
  private BoardProgressMeterText: MeterBehavior;
  private BoardProgress: Bitmap;
  private BoardProgressHighlight: Bitmap;
  private boardProgressbarBorderEffect: SpineBase;
  private progressMask: Graphics;
  private currentLevelProgress: number = 0
  private category: any = {
    "symbol51": "NoteBack",
    "symbol52": "Magnify",
    "symbol53": "Key"
  };

  // private freeSpinProgressSpin: SpineBase;

  protected initializeComponent(): void {
    super.initializeComponent();
    // this.reelMask = this.view.getShapeById(this.STR_REEL_MASK);
    this.NoteBackMeterText = this.view.getMeterById('NoteBackMeterText') as MeterBehavior;
    this.MagnifyMeterText = this.view.getMeterById('MagnifyMeterText') as MeterBehavior;
    this.KeyMeterText = this.view.getMeterById('KeyMeterText') as MeterBehavior;
    this.BoardProgressMeterText = this.view.getMeterById('BoardProgressMeterText') as MeterBehavior;
    this.boardButton = this.view.getButtonById("boardButton") as ButtonBase;
    this.BoardProgress = this.view.getImageById('BoardProgress');
    this.boardButton.on(ButtonBaseBehavior.UP, this.onBoardButtonPressedUp.bind(this), this);
    this.progressMask = this.view.getShapeById("progressBarMask")
    this.BoardProgress.mask = this.progressMask
    // this.boardButton.buttonMode = true;
    // this.boardButton.interactive = true;
    // this.boardButton.on(ButtonBase.UP, this.onBoardButtonPressedUp, this);
    this.reelBgAnim = this.view.getSpineById("Basegame_Desktop");
    this.BoardProgressHighlight = this.view.getImageById('BoardProgressHighlight');
  }

  protected subscribeEvents(): void {
    dispatcher.on(eventDispatchers.UPDATE_METER_VALUES, this.updateMeterValues, this);
    dispatcher.on(eventDispatchers.HIDE_BASEGAME_REEL, this.hideReelView, this);
    dispatcher.on(eventDispatchers.PLAY_BLAST_ON_WIN_METER, this.playBlastAnimOnWinMeter, this);
    dispatcher.on(eventDispatchers.PLAY_REVEALED_CLUE_ANIMATION, this.startBorderAnim, this)
    dispatcher.on(eventDispatchers.ALIGN_PROGRESS_BAR, this.alignProgressBar, this)
    super.subscribeEvents();
  }

  private startBorderAnim(): void {
    let clueRevealed = (ingenuity.parserModel as GameParserModel).getclueRevealedInfo().pickedClue;
    this.zoomInOutClue(this.category[clueRevealed]);
    let clueSpine = this.view.getSpineById(`borderEffect${this.category[clueRevealed]}`);
    let borderSpine = this.view.getSpineById('boardProgressbarBorderEffect');
    let anim: string;
    if (clueRevealed == 'symbol51') {
      anim = 'symbol_effect_red';
    } else if (clueRevealed == 'symbol52') {
      anim = 'symbol_effect_purple';
    } else {
      anim = 'symbol_effect_sky';
    }
    clueSpine.setPause(false);
    clueSpine.visible = true;
    clueSpine.playAnim(anim, true);
    borderSpine.setPause(false);
    borderSpine.visible = true;
    borderSpine.playAnim('metter_effect_win_loop', true);
    delayedCall('startInvestigation', SlotConstantsBehavior.DURATION_2000, () => {
      killDelayedCall('startInvestigation');
      this.stopBorderAnimations(clueSpine, borderSpine)
    })
  }

  private zoomInOutClue(clue: string): void {
    let meter = this.view.getContainerByID(`${clue}TweenContainer`);
    let meterTween = ingenuity.currentGame.add.tween(meter.scale).to({ x: 1.1, y: 1.1 }, SlotConstantsBehavior.DURATION_1000, Linear.None, true, 100, -1, true);
    delayedCall('stopTweens', SlotConstantsBehavior.DURATION_2000, () => {
      killDelayedCall('stopTweens');
      meterTween.stop();
      ingenuity.currentGame.tweens.remove(meterTween);
    })
  }

  private stopBorderAnimations(clueSpine: SpineBase, borderSpine: SpineBase): void {
    borderSpine.setPause(true);
    borderSpine.visible = false;
    clueSpine.setPause(true);
    clueSpine.visible = false;
    dispatcher.fireEvent(eventDispatchers.START_CLUE_REVEAL);

  }
  private onBoardButtonPressedUp(): void {
    dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, { id: SoundConstant.COMMON_CLICK_SOUND, vol: 1, loop: false, key: SlotConstantsBehavior.SOUND_LIST_PRELOAD });
    this.boardButton.disableAndTint();
    dispatcher.fireEvent(eventDispatchers.SHOW_INVESTINGATION_ROOM);
  }

  protected onShowBaseGame(evt: IEvent): void {
    dispatcher.fireEvent(EventConstants.UPDATE_CREDIT_VALUE);
    !(ingenuity.parserModel as GameParserModel).getClueRevealedFeatureStatus() && dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_BASE_GAME_WIN_METER);
    this.updateJackpotMeters();
    this.updateBonusAmt();
    this.view.getContainerByID("buttonsContainer").visible = true;
    this.view.show();
    dispatcher.fireEvent(SlotEventConstantsBehavior.CHANGE_BACKGROUND, SlotConstantsBehavior.BASEGAME_BG_SHOW);
    this.showBasegameByFadeIn();
    dispatcher.fireEvent(SlotEventConstantsBehavior.INITIALIZE_TOP_LOGO);
    this.playBaseGameSoundsAfterGameIntro();
    this.hideAutoplayButtons();
    this.hideTurboButtons();
    this.hideForceStopButton();
    this.view.getContainerByID("portraitButtonsContainer") && (this.view.getContainerByID("portraitButtonsContainer").visible = true);




    this.boardButton.enableAndTint();
    this.setReelMask();
    this.playBaseGameReelBgAnim();
    if ((ingenuity.parserModel as GameParserModel).getPreCollectMeterData() !== undefined && ingenuity.configData.isBrokenGame) {
      this.progressMeterValues((ingenuity.parserModel as GameParserModel).getPreCollectMeterData());
    } else {
      this.progressMeterValues((ingenuity.parserModel as GameParserModel).getCollectMeterData());
    }
  }

  private updateMeterValues(evt: IEvent): void {
    let symbol: number = evt.data.symbol;
    let specialSymbol: Bitmap;
    let collect_anim: SpineBase;
    switch (symbol) {
      case 11:
        collect_anim = this.view.getSpineById('collectEffectNote');
        specialSymbol = this.view.getImageById('NoteBack');
        break;
      case 12:
        collect_anim = this.view.getSpineById('collectEffectMagnify');
        specialSymbol = this.view.getImageById('Magnify');

        break;
      case 13:
        collect_anim = this.view.getSpineById('collectEffecKey');
        specialSymbol = this.view.getImageById('Key');
        break;
    }
    this.zoomSpecialSymbol(specialSymbol, symbol);
    ingenuity.configData.currentProgressingFill = true
    this.progressMeterValues((ingenuity.parserModel as GameParserModel).getCollectMeterData());
    collect_anim.visible = true;
    collect_anim.playAnim('collect_effect', true);
    collect_anim.onComplete.addOnce(() => {
      collect_anim.visible = false;
    });

  }

  protected playBorderEffects(): void {
    this.boardProgressbarBorderEffect = this.view.getSpineById('boardProgressbarBorderEffect');
    this.boardProgressbarBorderEffect.visible = true;
    this.boardProgressbarBorderEffect.playAnim('metter_effect_win_loop', true);
    this.view.getSpineById('borderEffectNoteBack').visible = true;
    this.view.getSpineById('borderEffectNoteBack').playAnim('symbol_effect_red', true);
    this.view.getSpineById('borderEffectMagnify').visible = true;
    this.view.getSpineById('borderEffectMagnify').playAnim('symbol_effect_purple', true);
    this.view.getSpineById('borderEffectKey').visible = true;
    this.view.getSpineById('borderEffectKey').playAnim('symbol_effect_sky', true)

  }

  private zoomSpecialSymbol(symbol: Bitmap, symbolId: number): void {
    let baseZoomInTween: ITween = ingenuity.currentGame.add.tween(symbol.scale).to({ x: 1.2, y: 1.2 }, SlotConstantsBehavior.DURATION_300, Linear.None, true, 0, 0, true);
    baseZoomInTween.onComplete.addOnce(() => {
      baseZoomInTween.stop();
      ingenuity.currentGame.tweens.remove(baseZoomInTween);
    }, this);
  }

  private progressMeterValues(meterData: any): void {
    let limitData: any
    if ((ingenuity.parserModel as GameParserModel).getPreCollectMeterLimitData() !== undefined) {
      limitData = (ingenuity.parserModel as GameParserModel).getPreCollectMeterLimitData();
    } else {
      limitData = (ingenuity.parserModel as GameParserModel).getCollectLimitData();
    }
    if (!meterData) return;
    this.NoteBackMeterText.setValue(meterData.symbol51);
    this.MagnifyMeterText.setValue(meterData.symbol52);
    this.KeyMeterText.setValue(meterData.symbol53);
    const totalSymbolCollected = (meterData.symbol51 > limitData.symbol51 ? limitData.symbol51 : meterData.symbol51) + (meterData.symbol52 > limitData.symbol52 ? limitData.symbol52 : meterData.symbol52) + (meterData.symbol53 > limitData.symbol53 ? limitData.symbol53 : meterData.symbol53);
    this.storeSymbolLimit(meterData, limitData);
    this.handleLimitReached(meterData, limitData);
    const totalLimit = limitData.symbol51 + limitData.symbol52 + limitData.symbol53;
    const totalProgress = totalSymbolCollected / totalLimit;
    let progressPercent = "0";
    if (totalSymbolCollected) {
      progressPercent = (totalProgress * 100).toFixed(2) + '%'
    } else {
      progressPercent = "0%"
    }
    this.BoardProgressMeterText.setText(progressPercent);
    if (totalProgress === 0) {
      this.BoardProgressHighlight.visible = false;
      this.currentLevelProgress = 0;
      this.view.getContainerByID("progressingUpdateContainer").x = 0;
    }
    else {
      this.BoardProgressHighlight.visible = true;
      const progressTween = ingenuity.currentGame.add.tween(this.view.getContainerByID("progressingUpdateContainer"));
      this.currentLevelProgress = totalProgress * gameConstants.PROGRESS_SHIFT_LIMIT;
      progressTween.to({ x: this.currentLevelProgress }, SlotConstantsBehavior.DURATION_1000, Linear.None, true, 0);
      progressTween.onComplete.addOnce(() => {
        progressTween.stop();
        ingenuity.currentGame.tweens.remove(progressTween);
      });
    }
  }
  private storeSymbolLimit(meterData: any, limitData: any): void {
    if (meterData.symbol51 >= limitData.symbol51) {
      !ingenuity.configData.isSymbolLimitReached[gameConstants.SPECIAL_SYMBOL_NOTE] && this.playLimitReachedSound();
      ingenuity.configData.isSymbolLimitReached[gameConstants.SPECIAL_SYMBOL_NOTE] = true;
    }
    if (meterData.symbol52 >= limitData.symbol52) {
      !ingenuity.configData.isSymbolLimitReached[gameConstants.SPECIAL_SYMBOL_MAGNIFY] && this.playLimitReachedSound();
      ingenuity.configData.isSymbolLimitReached[gameConstants.SPECIAL_SYMBOL_MAGNIFY] = true;
    }
    if (meterData.symbol53 >= limitData.symbol53) {
      !ingenuity.configData.isSymbolLimitReached[gameConstants.SPECIAL_SYMBOL_KEY] && this.playLimitReachedSound();
      ingenuity.configData.isSymbolLimitReached[gameConstants.SPECIAL_SYMBOL_KEY] = true;
    }
  }
  private playLimitReachedSound(): void {
    ingenuity.configData.currentProgressingFill && (ingenuity.soundManager as any).playSound(SoundConstantGame.SPECIAL_PB_WIN, SlotConstantsBehavior.SOUND_LIST_PRELOAD);
  }
  private handleLimitReached(meterData: any, limitData: any): void {
    if (meterData.symbol51 >= limitData.symbol51) {
      this.view.getImageById("NoteBackCheck").visible = true
      this.NoteBackMeterText.visible = false;
    } else {
      this.view.getImageById("NoteBackCheck").visible = false
      this.NoteBackMeterText.visible = true;
    }

    if (meterData.symbol52 >= limitData.symbol52) {
      this.view.getImageById("MagnifyCheck").visible = true
      this.MagnifyMeterText.visible = false;
    } else {
      this.MagnifyMeterText.visible = true;
      this.view.getImageById("MagnifyCheck").visible = false
    }

    if (meterData.symbol53 >= limitData.symbol53) {
      this.KeyMeterText.visible = false;
      this.view.getImageById("KeyCheck").visible = true
    } else {
      this.KeyMeterText.visible = true;
      this.view.getImageById("KeyCheck").visible = false
    }
  }
  private alignProgressBar(): void {
    this.view.getContainerByID("progressingUpdateContainer").x = this.currentLevelProgress;
  }
  protected onHideBaseGame(): void {
    super.onHideBaseGame();
    this.stopBaseGameReelBgAnim();
  }

  private playBaseGameReelBgAnim(): void {
    this.reelBgAnim.visible = true;
    this.reelBgAnim.setPause(false);
    this.reelBgAnim.playAnim("basegame_idle_desktop_reel_glow", true);
  }

  private stopBaseGameReelBgAnim(): void {
    this.reelBgAnim.visible = false;
    this.reelBgAnim.setPause(true);
  }
  /**
 * play blast anim on console panel
 */
  private playBlastAnimOnWinMeter(): void {
    const lightAnim: SpineBase = this.view.getSpineById("lightHitAnimation");
    lightAnim.visible = true;
    lightAnim.playAnim('Win_meter_blast');
    lightAnim.onComplete.addOnce(() => {
      lightAnim.visible = false;
    })
  }

  private setReelMask(): void {
    this.view.mask = this.view.getShapeById("reelMask");
  }
  /**
   * handle intro sounds in basegame
   */
  playBaseGameSoundsAfterGameIntro() {
    if (!(ingenuity.parserModel as GameParserModel).getFreeGameBroken()) {
      if (!(ingenuity.parserModel as GameParserModel).getIsFreeSpintriggered() && !SlotConstantsBehavior.FREEGAME_RETURN_SOUND) {
        dispatcher.fireEvent(SlotEventConstantsBehavior.HANDLE_MULTIPLE_SOUND, {
          initialSound: { id: SoundConstant.BASEGAME_BGM_INTRO, vol: 1, loop: false, key: SlotConstantsBehavior.SOUND_LIST_PRELOAD },
          onCompletedSound: { id: SoundConstant.BASEGAME_BGMLOOP, vol: 1, loop: true, key: SlotConstantsBehavior.SOUND_LIST_PRELOAD }
        });
      }
      else {
        dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, { id: SoundConstant.BASEGAME_BGMLOOP, vol: 1, loop: true, key: SlotConstantsBehavior.SOUND_LIST_PRELOAD });
      }
      SlotConstantsBehavior.FREEGAME_RETURN_SOUND = false;
    }
  }
  private hideReelView() {
    this.view.hide();
  }
}
